var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 12.5863V11.413C5.33325 10.7196 5.89992 10.1463 6.59992 10.1463C7.80659 10.1463 8.29992 9.29297 7.69325 8.2463C7.34659 7.6463 7.55325 6.8663 8.15992 6.51963L9.31325 5.85963C9.83992 5.5463 10.5199 5.73297 10.8333 6.25963L10.9066 6.3863C11.5066 7.43297 12.4933 7.43297 13.0999 6.3863L13.1733 6.25963C13.4866 5.73297 14.1666 5.5463 14.6933 5.85963L15.8466 6.51963C16.4533 6.8663 16.6599 7.6463 16.3133 8.2463C15.7066 9.29297 16.1999 10.1463 17.4066 10.1463C18.0999 10.1463 18.6733 10.713 18.6733 11.413V12.5863C18.6733 13.2796 18.1066 13.853 17.4066 13.853C16.1999 13.853 15.7066 14.7063 16.3133 15.753C16.6599 16.3596 16.4533 17.133 15.8466 17.4796L14.6933 18.1396C14.1666 18.453 13.4866 18.2663 13.1733 17.7396L13.0999 17.613C12.4999 16.5663 11.5133 16.5663 10.9066 17.613L10.8333 17.7396C10.5199 18.2663 9.83992 18.453 9.31325 18.1396L8.15992 17.4796C7.55325 17.133 7.34659 16.353 7.69325 15.753C8.29992 14.7063 7.80659 13.853 6.59992 13.853C5.89992 13.853 5.33325 13.2796 5.33325 12.5863Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.67bb389904b64033a39d06107c6f50ce.svg";
export { ForwardRef as ReactComponent };